import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import toast from 'react-hot-toast';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [usuario,   setUsuario]   = useState(null);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    const token   = localStorage.getItem('kairos_access_token');
    const userStr = localStorage.getItem('kairos_usuario');
    if (token && userStr) {
      setUsuario(JSON.parse(userStr));
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }
    setCarregando(false);
  }, []);

  const login = useCallback(async (email, senha) => {
    const { data } = await api.post('/auth/login', { email, senha });
    localStorage.setItem('kairos_access_token',  data.accessToken);
    localStorage.setItem('kairos_refresh_token', data.refreshToken);
    localStorage.setItem('kairos_usuario',       JSON.stringify(data.usuario));
    api.defaults.headers.common['Authorization'] = `Bearer ${data.accessToken}`;
    setUsuario(data.usuario);
    return data.usuario;
  }, []);

  const logout = useCallback(async () => {
    const refreshToken = localStorage.getItem('kairos_refresh_token');
    try { await api.post('/auth/logout', { refreshToken }); } catch {}
    localStorage.removeItem('kairos_access_token');
    localStorage.removeItem('kairos_refresh_token');
    localStorage.removeItem('kairos_usuario');
    delete api.defaults.headers.common['Authorization'];
    setUsuario(null);
    toast.success('Sessão encerrada.');
  }, []);

  return (
    <AuthContext.Provider value={{ usuario, carregando, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
